import(/* webpackMode: "eager" */ "/vercel/path0/app/(frontend)/(site)/error.tsx");
